import { useState } from 'react';

// Número de destino no formato internacional (sem + ou espaços)
const WHATSAPP_NUMBER = '5511930672567';

export default function Contato() {
  const [fields, setFields] = useState({ nome: '', email: '', mensagem: '' });

  // Atualiza o estado conforme o usuário digita
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFields((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Ao clicar em Enviar: monta a mensagem e abre o WhatsApp em nova aba
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    // Impede o comportamento padrão do formulário (sem reload, sem POST)
    e.preventDefault();

    // Monta a mensagem com a estrutura exata solicitada
    const mensagem =
      `Nome Completo: ${fields.nome} | E-mail: ${fields.email} | Motivo do Contato: ${fields.mensagem}`;

    // Codifica a mensagem para uso seguro na URL
    const mensagemCodificada = encodeURIComponent(mensagem);

    // Monta o link do WhatsApp e abre em nova aba
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${mensagemCodificada}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="contato" className="py-24 md:py-32 bg-[#FAF8FA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

          {/* Coluna esquerda — informações de contato */}
          <div>
            <span className="inline-flex items-center gap-2 px-4 py-1.5 border border-[#D6C4D6] text-[#301531] font-montserrat text-xs font-semibold tracking-[0.2em] uppercase rounded-full mb-6">
              Contato
            </span>
            <h2
              className="font-gothic text-[#301531] leading-tight mb-6"
              style={{ fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)' }}
            >
              Vamos conversar?
            </h2>
            <p className="font-montserrat text-[#1A1A1A] text-base leading-relaxed mb-10">
              Preencha o formulário ou entre em contato diretamente. Estamos prontos para transformar seu espaço com planejamento estratégico e design de interiores de alto padrão.
            </p>

            <div className="space-y-6">
              <a href="tel:+5511930672567" className="flex items-center gap-4 group cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-[#301531] rounded-xl flex-shrink-0">
                  <i className="ri-phone-line text-white text-lg" />
                </div>
                <div>
                  <div className="font-montserrat text-xs text-[#BCBDBF] uppercase tracking-widest mb-0.5">Telefone</div>
                  <div className="font-montserrat font-semibold text-[#301531] group-hover:text-[#4a2050] transition-colors">(11) 93067-2567</div>
                </div>
              </a>

              <a href="https://instagram.com/intrearquitetura" target="_blank" rel="nofollow noreferrer" className="flex items-center gap-4 group cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-[#301531] rounded-xl flex-shrink-0">
                  <i className="ri-instagram-line text-white text-lg" />
                </div>
                <div>
                  <div className="font-montserrat text-xs text-[#BCBDBF] uppercase tracking-widest mb-0.5">Instagram</div>
                  <div className="font-montserrat font-semibold text-[#301531] group-hover:text-[#4a2050] transition-colors">@intrearquitetura</div>
                </div>
              </a>

              <a href="https://wa.me/5511930672567" target="_blank" rel="nofollow noreferrer" className="flex items-center gap-4 group cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-[#301531] rounded-xl flex-shrink-0">
                  <i className="ri-whatsapp-line text-white text-lg" />
                </div>
                <div>
                  <div className="font-montserrat text-xs text-[#BCBDBF] uppercase tracking-widest mb-0.5">WhatsApp</div>
                  <div className="font-montserrat font-semibold text-[#301531] group-hover:text-[#4a2050] transition-colors">(11) 93067-2567</div>
                </div>
              </a>
            </div>
          </div>

          {/* Coluna direita — formulário */}
          <div className="bg-white rounded-3xl p-8 md:p-10" style={{ boxShadow: '0 4px 32px rgba(48,21,49,0.07)' }}>
            <form onSubmit={handleSubmit} className="space-y-6">

              {/* Campo: Nome Completo */}
              <div>
                <label
                  htmlFor="nome"
                  className="block font-montserrat text-xs font-semibold text-[#301531] uppercase tracking-widest mb-2"
                >
                  Nome Completo
                </label>
                <input
                  id="nome"
                  type="text"
                  name="nome"
                  required
                  value={fields.nome}
                  onChange={handleChange}
                  placeholder="Seu nome completo"
                  className="w-full border-b-2 border-[#BCBDBF] bg-transparent py-3 font-montserrat text-sm text-[#1A1A1A] placeholder-[#BCBDBF] focus:outline-none focus:border-[#301531] transition-colors duration-300"
                />
              </div>

              {/* Campo: E-mail */}
              <div>
                <label
                  htmlFor="email"
                  className="block font-montserrat text-xs font-semibold text-[#301531] uppercase tracking-widest mb-2"
                >
                  E-mail
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  required
                  value={fields.email}
                  onChange={handleChange}
                  placeholder="seu@email.com"
                  className="w-full border-b-2 border-[#BCBDBF] bg-transparent py-3 font-montserrat text-sm text-[#1A1A1A] placeholder-[#BCBDBF] focus:outline-none focus:border-[#301531] transition-colors duration-300"
                />
              </div>

              {/* Campo: Mensagem */}
              <div>
                <label
                  htmlFor="mensagem"
                  className="block font-montserrat text-xs font-semibold text-[#301531] uppercase tracking-widest mb-2"
                >
                  Mensagem
                </label>
                <textarea
                  id="mensagem"
                  name="mensagem"
                  required
                  rows={4}
                  maxLength={500}
                  value={fields.mensagem}
                  onChange={handleChange}
                  placeholder="Conte um pouco sobre seu projeto..."
                  className="w-full border-b-2 border-[#BCBDBF] bg-transparent py-3 font-montserrat text-sm text-[#1A1A1A] placeholder-[#BCBDBF] focus:outline-none focus:border-[#301531] transition-colors duration-300 resize-none"
                />
                {/* Contador de caracteres */}
                <div className="text-right font-montserrat text-xs text-[#BCBDBF] mt-1">
                  {fields.mensagem.length}/500
                </div>
              </div>

              {/* Botão de envio — abre WhatsApp com mensagem pronta */}
              <button
                type="submit"
                className="w-full py-4 bg-[#301531] text-white font-montserrat font-bold text-sm rounded-xl hover:bg-[#4a2050] transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                <i className="ri-whatsapp-line text-base" />
                Enviar mensagem
              </button>

              <p className="text-center font-montserrat text-xs text-[#BCBDBF] leading-relaxed">
                Ao clicar em enviar, você será direcionado ao WhatsApp com sua mensagem já preenchida.
              </p>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
}
